import { Day } from "PFApp/booking/parts/overview/context/use_calendar_days";
import React from "react";

import css from "../../days/days.module.scss";
import { useCalendarHeader } from "../use_calendar_header";
import { DayItem } from "./day_item";

type DaysProps = {
  days: Day[];
};

export const Days = ({ days }: DaysProps): JSX.Element | null => {
  const { daysHeight } = useCalendarHeader();

  return daysHeight ? (
    <div className={css.root} style={{ height: daysHeight }}>
      {days.map((day) => (
        <DayItem key={`day_${day.date.getTime()}`} day={day} daysHeight={daysHeight} />
      ))}
    </div>
  ) : null;
};
